import { Injectable, inject } from '@angular/core';
import { SessionTimeoutService } from '@services/session-timeout.service';

@Injectable({
  providedIn: 'root'
})
export class SessionInitService {
  private sessionTimeoutService = inject(SessionTimeoutService);

  /**
   * Backend owns idle timeout enforcement; retained for existing auth bootstrap calls.
   */
  initializeSessionIfLoggedIn(): void {
    this.sessionTimeoutService.initializeSessionTimeout();
  }

  /**
   * Clean up any frontend session state owned by SessionTimeoutService.
   */
  cleanupSession(): void {
    this.sessionTimeoutService.cleanup();
  }
}
